var _path, _path2, _g, _path3, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNewLookupSmall = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 65,
  height: 64,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F2F8FC",
  d: "M32.506 62.799c17.007 0 30.795-13.788 30.795-30.795S49.513 1.209 32.506 1.209 1.71 14.996 1.71 32.004c0 17.007 13.787 30.795 30.795 30.795"
})), /*#__PURE__*/React.createElement("mask", {
  id: "new_lookup_small_svg__a",
  width: 35,
  height: 35,
  x: 16,
  y: 14,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M16.855 14.223h34.133v34.133H16.855z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#new_lookup_small_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#00E2BC",
  d: "M20.766 41.245a1.03 1.03 0 0 1-.76-.309 1.04 1.04 0 0 1-.307-.764q0-.456.307-.758a1.04 1.04 0 0 1 .76-.303h12.089q.453 0 .76.309.306.309.306.764 0 .456-.306.759a1.04 1.04 0 0 1-.76.302zm0-7.467q-.454 0-.76-.308a1.04 1.04 0 0 1-.307-.765q0-.455.307-.758a1.04 1.04 0 0 1 .76-.302h4.978q.453 0 .76.308.306.308.306.765 0 .455-.306.758a1.04 1.04 0 0 1-.76.302zm0-7.467a1.03 1.03 0 0 1-.76-.308 1.04 1.04 0 0 1-.307-.765q0-.455.307-.758a1.04 1.04 0 0 1 .76-.302h4.978q.453 0 .76.308.306.309.306.765t-.306.758a1.04 1.04 0 0 1-.76.302zm16 10.667q-2.952 0-5.031-2.08-2.08-2.08-2.08-5.031t2.08-5.031 5.03-2.08 5.032 2.08 2.08 5.031q0 1.137-.356 2.204a6.8 6.8 0 0 1-1.066 1.992l4.942 4.942q.32.32.32.746 0 .428-.32.747-.32.32-.747.32-.426 0-.746-.32l-4.943-4.942q-.924.711-1.99 1.067a7 7 0 0 1-2.205.355m-.008-2.133q2.07 0 3.528-1.45t1.458-3.52-1.45-3.528q-1.45-1.458-3.52-1.458t-3.528 1.45-1.458 3.52 1.45 3.528q1.45 1.458 3.52 1.458"
}))), /*#__PURE__*/React.createElement("mask", {
  id: "new_lookup_small_svg__b",
  width: 23,
  height: 35,
  x: 28,
  y: 14,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#D9D9D9",
  d: "M28.234 14.223H50.99v34.133l-11.378-5.689-11.378-8.889z"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#new_lookup_small_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#0A78CD",
  d: "M20.766 41.245a1.03 1.03 0 0 1-.76-.309 1.04 1.04 0 0 1-.307-.764q0-.456.307-.758a1.04 1.04 0 0 1 .76-.303h12.089q.453 0 .76.309.306.309.306.764 0 .456-.306.759a1.04 1.04 0 0 1-.76.302zm0-7.467q-.454 0-.76-.308a1.04 1.04 0 0 1-.307-.765q0-.455.307-.758a1.04 1.04 0 0 1 .76-.302h4.978q.453 0 .76.308.306.308.306.765 0 .455-.306.758a1.04 1.04 0 0 1-.76.302zm0-7.467a1.03 1.03 0 0 1-.76-.308 1.04 1.04 0 0 1-.307-.765q0-.455.307-.758a1.04 1.04 0 0 1 .76-.302h4.978q.453 0 .76.308.306.309.306.765t-.306.758a1.04 1.04 0 0 1-.76.302zm16 10.667q-2.952 0-5.031-2.08-2.08-2.08-2.08-5.031t2.08-5.031 5.03-2.08 5.032 2.08 2.08 5.031q0 1.137-.356 2.204a6.8 6.8 0 0 1-1.066 1.992l4.942 4.942q.32.32.32.746 0 .428-.32.747-.32.32-.747.32-.426 0-.746-.32l-4.943-4.942q-.924.711-1.99 1.067a7 7 0 0 1-2.205.355m-.008-2.133q2.07 0 3.528-1.45t1.458-3.52-1.45-3.528q-1.45-1.458-3.52-1.458t-3.528 1.45-1.458 3.52 1.45 3.528q1.45 1.458 3.52 1.458"
}))));
export default SvgNewLookupSmall;